import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 24 18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 14.667v2.666H8v-2.666h8zm2.667-7.334V10H5.333V7.333h13.334zM24 0v2.667H0V0h24z" /></svg>);